import { Http } from '@/utils/request';
import { CreateTeamType } from './type/create.d';
import { TeamDetailType } from './type/responseTeam.d';

export const getCurrentTeam = async (params: { teamId: string }) => {
  return await Http.get(`open-app-bff/users/me/teams/${params.teamId}`).json<
    APIRes<TeamDetailType>
  >();
};

export const createTeam = async (params: CreateTeamType) => {
  return await Http.post(`open-app-bff/users/me/teams`, {
    json: params,
  }).json<APIRes<CreateTeamType>>();
};

export const updateTeam = async (teamId: string, params: CreateTeamType) => {
  return await Http.put(`open-app-bff/users/me/teams/${teamId}`, {
    json: params,
  }).json<APIRes<CreateTeamType>>();
};

//提交审核
export const submitTeamReview = async (params: { teamId: string }) => {
  return await Http.post(`open-app-bff/users/me/teams/${params.teamId}/reviews`, { json: {} }).json<
    APIRes<never>
  >();
};
